import script from "./SingleImgCom.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleImgCom.vue?vue&type=script&setup=true&lang=js"

import "./SingleImgCom.vue?vue&type=style&index=0&id=7be5bb46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be5bb46"]])

export default __exports__